import styled from "styled-components/macro"
import { Card, IconButton, SearchableSelect, Timeline } from "@humanpredictiveintelligence/myqvt-library"

import { LazyQuestionChoices } from "../LazyQuestionChoices"

export const Container = styled(Card)`
  width: 50%;
  min-height: 100vh;
  padding: 0;
  display: flex;
  flex-direction: column;
  overflow: initial;
`

export const SectionTitle = styled.div`
  padding: 12px 24px;
`

export const ThemeSelect = styled(SearchableSelect)`
  padding: 12px 24px;
`

export const QuestionList = styled(Timeline)`
  padding: 0 24px;
`

export const EmptyQuestionList = styled.div`
  margin: auto;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const Question = {
  Action: styled(IconButton)`
    position: absolute;
    right: 0;
    top: 0;
  `,
  Choices: styled(LazyQuestionChoices)`
    margin-bottom: 16px;
  `,
  Wording: styled.div`
    font-weight: ${({ theme }) => theme.typography.fontWeightMedium};
    max-width: 90%;
  `,
}
